// extracted by mini-css-extract-plugin
export default {"root":"jT34k","offersContainer":"JHiFo","banners":"zm0J5","offersGrid":"gbxEC","hidden":"T1Iyi","banner":"FVeEt","offer":"yzGYH","wrapperCurrencyPicker":"XCcYG"};